export const baseUrl = import.meta.env.PROD ? '' : '';

export const apiUrl = import.meta.env.PROD ? window.location.origin : 'http://localhost:5000';
